/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelinePlacementDto } from './traveline-placement-dto';
import {
    TravelinePlacementDtoFromJSON,
    TravelinePlacementDtoFromJSONTyped,
    TravelinePlacementDtoToJSON,
    TravelinePlacementDtoToJSONTyped,
} from './traveline-placement-dto';

/**
 * 
 * @export
 * @interface TravelineRoomTypeDto
 */
export interface TravelineRoomTypeDto {
    /**
     * Room type identifier
     * @type {string}
     * @memberof TravelineRoomTypeDto
     */
    id: string;
    /**
     * Accommodations entity
     * @type {Array<TravelinePlacementDto>}
     * @memberof TravelineRoomTypeDto
     */
    placements?: Array<TravelinePlacementDto>;
}

/**
 * Check if a given object implements the TravelineRoomTypeDto interface.
 */
export function instanceOfTravelineRoomTypeDto(value: object): value is TravelineRoomTypeDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function TravelineRoomTypeDtoFromJSON(json: any): TravelineRoomTypeDto {
    return TravelineRoomTypeDtoFromJSONTyped(json, false);
}

export function TravelineRoomTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineRoomTypeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'placements': json['placements'] == null ? undefined : ((json['placements'] as Array<any>).map(TravelinePlacementDtoFromJSON)),
    };
}

  export function TravelineRoomTypeDtoToJSON(json: any): TravelineRoomTypeDto {
      return TravelineRoomTypeDtoToJSONTyped(json, false);
  }

  export function TravelineRoomTypeDtoToJSONTyped(value?: TravelineRoomTypeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'placements': value['placements'] == null ? undefined : ((value['placements'] as Array<any>).map(TravelinePlacementDtoToJSON)),
    };
}

